var map = {
	"./bg.json": 6,
	"./cs.json": 7,
	"./de.json": 8,
	"./es.json": 9,
	"./fr.json": 10,
	"./hr.json": 11,
	"./hu.json": 12,
	"./it.json": 13,
	"./ro.json": 14,
	"./sk.json": 4,
	"./sl.json": 15
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 44;
module.exports = webpackAsyncContext;